import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import useVelocityClient from '../useVelocityClient';
import useVelocityClientIsReady from '../useVelocityClientIsReady';
import { useQuery } from '@tanstack/react-query';

export function isSignedMsgUserOrdersAccountInitializedQueryKey(
	walletPublicKeyBase58?: string
) {
	return ['isSignedMsgUserOrdersAccountInitialized', walletPublicKeyBase58];
}

/**
 * Note, will return `undefined` if the user's account does not yet exist.
 */
export const useIsSignedMsgUserOrdersAccountInitialized = () => {
	const velocityClient = useVelocityClient();
	const velocityClientIsReady = useVelocityClientIsReady();
	const authority = useVelocityAccountStore(
		(s) => s.getCurrentUserAccount()?.authority
	);
	const userAccountExists = useVelocityAccountStore(
		(s) => !!s.getCurrentUserAccount()
	);

	const isDisabled =
		!velocityClient ||
		!velocityClientIsReady ||
		!authority ||
		!userAccountExists;

	return useQuery({
		queryKey: isSignedMsgUserOrdersAccountInitializedQueryKey(
			authority?.toBase58()
		),
		queryFn: () => {
			if (isDisabled) {
				return;
			}

			return velocityClient?.isSignedMsgUserOrdersAccountInitialized(authority);
		},
		enabled: !isDisabled,
		staleTime: Infinity,
	});
};
